import React, { Component } from 'react';
import {WingBlank,SearchBar, NavBar, List, Button, Toast,Icon} from 'antd-mobile';

class TabContent extends Component {
    constructor(props) {
        super(props);
    }
    storeDetail = (e)=>{
        const storeId = e.currentTarget.getAttribute("data-name");
        this.props.storeDetail(storeId);
    };
    checkStore = (city)=>{
        this.props.checkStore(city);
    };
    render() {
        const tabContents = this.props.tabContents;
        return (
            <ul className="placeholder tabs-right">
                {
                    tabContents.map((tabContent,index) => {
                        return (<li key={ index.toString() } className="store-item">
                            <div className="store-info">
                                <div onClick={() => this.checkStore({...tabContent})}>
                                    <div className="store-title"><span>{tabContent.storeName}</span><img className="store-img" src="/assets/StoreSelection_Store.png" /></div>
                                    <span className="store-address">{tabContent.address}</span>
                                </div>
                            </div>
                            <div onClick={this.storeDetail} data-name={tabContent.storeId} className="store-detail"><Icon type="right" size="lg" color="#a8a8a8"/></div>
                        </li>);
                    })
                }
            </ul>
        );

    }
}

export default TabContent;